<template>
    <div id='app'>
        <slides nav-position='right' :slide-duration='0.75'>
            <section id='welcome'>
                <div class='content'>
                    <figure class='space-man'><img src='./assets/images/space-man.png'/></figure>
                    <div class='title'>
                        <figure class='logo vrs'><img src='./assets/images/logo-vrs.png'/></figure>
                        <figure class='logo tb'><img src='./assets/images/logo-tb.png'/></figure>
                        <h1>IP Development &amp; Production</h1>
                        <button class='go-next black'>Continue</button>
                    </div>
                </div>
            </section>
            <section id='preschool-to-primetime'>
                <div class='title'>
                    <h2>From Preschool to Primetime</h2>
                    <p>The Tremblay Brothers have been associated with some of the most important Hollywood Studios as independent creators-producers, and have created projects that have been produced and broadcasted in over 100+ countries around the world.  The Tremblays have been responsible for the design and manufacture of hundreds of licensed products based on their animated TV series as well as original product lines. They have also been working with Redfoo, the Looney Tunes, The Mask, WWE (World Wrestling Entertainment), the iconic Felix the Cat, to name a few.</p>
                </div>
                <div class='content'/>
            </section>

            <section id='introduction-to-next-steps'>
                <div class="title">
                    <h2>Introduction to Next Steps</h2>
                </div>
                <div class="content">
                    <div class='inner'>
                        Exclusive partnership between Village Roadshow and Tremblay Bros.
                        <div class="logos">
                            <img src="./assets/images/logo-vrs-black.png" class='vrs'>
                            <img src="./assets/images/logo-tb.png" class='tb'>
                        </div>
                    </div>
                    <div class="col">
                        <p>Development slate of new Kids & Family Entertainment Intellectual Properties for global exploitation across all media; Television, Games, Publishing, Movies, Merchandising, etc.</p>
                        <p>Independent development between our companies to leverage greater control in commercial exploitation of the subrights</p>
                        <p>Depending on the scale of the partnership, a Newco may be formed between Village and Tremblay Bros. Studios</p>
                    </div>
                </div>
            </section>
            
            <section id='intellectual-properties-evaluation-process'>
                <div class="title">
                    <h2>Intellectual Properties - Evaluation Process</h2>
                </div>
                <div class="content">
                    <p>Village Roadshow and Tremblay Bros. will evaluate together which IP they consider should go into development from either:</p>
                    <ul>
                       <li>
                            <img src="./assets/images/projects-swat-kats.png"/>
                            Tremblay Bros. Projects <small>Angry Jesus, Bearsy Bears, Swat-Kats, etc.</small></li>
                       <li>
                            <img src="./assets/images/projects-the-matrix.svg"/>
                            Village Roadshow’s Library  <small>Matrix, Mad Max. etc.</small></li>
                       <li>
                            <img src="./assets/images/projects-build-a-bear.png" alt="">
                            Corporate Brands  <small>Build a Bear, etc.</small></li>
                    </ul>
                    <p>In the event that a Newco is formed, Village Roadshow shall have the first refusal right for any existing and new Tremblay Bros. projects as well as future external projects that are brought to Tremblay Bros. Studios for considerations</p>
                </div>
            </section>

            <section id='ip-global-exploitation-across-all-media'>
                <div class="title">
                    <h2>Intellectual Properties Global Exploitation Acrosss All Media</h2>
                </div>
                <div class="content">
                    <figure class='ip'>
                        <div class="image"> <img src='./assets/images/ip-all.jpg'/></div>
                        <figcaption>Global</figcaption>
                    </figure>
                    <figure class='ip'>
                        <div class="image"> <img src='./assets/images/ip-interactive.jpg'/></div>
                        <figcaption>Interactive</figcaption>
                    </figure>
                    <figure class='ip'>
                        <div class="image"> <img src='./assets/images/ip-publishing.jpg'/></div>
                        <figcaption>Publishing</figcaption>
                    </figure>
                    <figure class='ip'>
                        <div class="image"> <img src='./assets/images/ip-merch.jpg'/></div>
                        <figcaption>Licensing &amp; Merch</figcaption>
                    </figure>
                    <figure class='ip'>
                        <div class="image"> <img src='./assets/images/ip-feature-film.jpg'/></div>
                        <figcaption>Feature Film</figcaption>
                    </figure>
                    <figure class='ip'>
                        <div class="image"> <img src='./assets/images/ip-television.jpg'/></div>
                        <figcaption>Television</figcaption>
                    </figure>
                </div>
            </section>
<!--             <section id='development'>
                <div class='title'>
                    <h2>Development</h2>
                </div>
                <div class='content'>
                    <div class="col">
                        <h3>Existing Village Roadshow IP</h3>
                        <p>Evaluate and select titles from the Village Roadshow library to for IP Development.</p>
                    </div>
                    <div class="col">
                        <h3>New Tremblay Bros Studio IP <small>(Bearsy Bears, Angry Jesus)</small></h3>
                        <p>Evaluate and select titles from Tremblay’s catalog of newly created IP in order to further Develop the titles for exploitation.</p>
                    </div>
                    <div class="col">
                       <h3>Exploit Existing TBS Rights <small>(SWAT Kats, Felix the Cat)</small></h3> 
                       <p>Develop TBS’ legacy IP titles, which have global mindshare, targeting existing and new audiences.</p>
                    </div>
                    <div class="col">
                        <h3>Brand Support <small>(Build A Bear, WWE)</small></h3>
                        <p>Develop new series to create relevancy for corporations and brands looking to connect with their current and next audience.</p>
                    </div>
                </div>
            </section>
 -->
            <section id='working-together'>
                <div class='title'>
                    <h2>10 IP NewCo vs. 3 IP Program</h2>
                    <p>Commercial Merchandising: Licensing & Brand Partnerships on Games, Toys, Apparel, and other Merchandising within 1st 12 months.</p>
                    <p>Shared IP Ownership % between Village Roadshow and Tremblay Bros.</p>
                </div>
                <div class='content'>
                    <div class='highlights'>
                        <div class='sub-title'>
                            <h3>Newco</h3>
                        </div>
                        <ul class='inner-content'>
                            <li>$5M Investment (Corporate & Operating Expenses, IP Development)</li>
                            <li>3 Years Development</li>
                            <li>10 or more IPs to be developed</li>
                            <li>TV/Film Goal: 3 Shows launched within 2 years, 6 Shows within 5 years</li>
                        </ul>
                    </div>
                    <div class='values'>
                        <div class='sub-title'>
                            <h3>Introductory Program</h3>
                        </div>
                        <ul class='inner-content'>
                            <li>Estimated $1.5M Development and Operating Expenses </li>
                            <li>1 Year Development</li>
                            <li>3 or more IPs to be developed</li>
                            <li>TV/Film Goal: 3 Shows launched within 2 years</li>
                        </ul>
                    </div>
                </div>
            </section>
            <section id='business-and-creative-development'>
                <div class="title">
                    <h2>Business &amp; Creative Development</h2>
                </div>
                <div class="grid">
                    <figure class='logo vrs'>
                        <img src="./assets/images/logo-vrs-black.png" />
                        <figcaption>
                            <span>Financier • Producer</span>
                            <small>Equity Partner</small>
                        </figcaption> 
                    </figure>
                    
                    <figure class='logo tbs'>
                        <img src="./assets/images/logo-tb.png" />
                        <figcaption>
                            <span>Creator • Producer</span>
                            <small>Equity Partner</small>
                        </figcaption> 
                    </figure>
                    
                    <figure class='logo newco'>
                        <img src="./assets/images/logo-newco.svg" />
                        <figcaption>
                            <span class='root'>Own &amp; Control Global Rights</span>
                            <small>IP's to be Created &amp; Transferred</small>
                        </figcaption> 
                    </figure>
                </div>
                
                <figure class='footer'>
                    <img src="./assets/images/business-creative-dev.jpg" />
                </figure>
            </section>

           <!--  <section id='projected-gross-revenues'>
                <div class="col">
                    <h2>Projected Gross Revenues</h2>
                    <ul>
                        <li><strong>1 Series for 1 Season</strong> <span>Gross: $XM</span></li>
                        <li><strong>1 Series for 2 Seasons</strong> <span>Gross: $XM</span></li>
                        <li><strong>1 Series for 3 Seasons</strong> <span>Gross: $XM</span></li>
                    </ul>
                    <p>Projections of revenues based on television series being greenlit for production. These projections are for television production & distribution revenues only, excluding any ancillary revenues, i.e. L&M, Publishing, Interactive, Film etc.</p>
                </div>
                <div class="col">

                </div>
            </section> -->
            
            <section id='thank-you'>
                <div class='title'>
                    <h2>Thank You</h2>
                </div>
                <div class="content">
                    <p>With the ever expending market of kids & family entertainment content,  the key is to create and develop well targeted high quality properties and own the underlying rights to build out franchise for global exploitation. Through a partnership of Village Roadshow and Tremblay Bros. Studios, we are leveraging the creation, development, production and control of a unique library of enduring kids & family content.</p>
                </div>
            </section>
        </slides>

        <div id='ui-display'>
            <div class="logo"><Logo/></div>
            <div class='slide-counter'><span>{{currentSlide + 1}} <small>/</small> {{totalSlides}}</span></div>
        </div>
        
    </div>
</template>

<script>

import Slides from './Slides.vue'
import Logo from './components/Logo.vue'
import Schedule from './components/Schedule.vue'
import LicensingMerchandising from './components/LicensingMerchandising.vue'

export default {
    name: 'App',
    components: {
        'slides': Slides,
        'Logo': Logo,
        'Schedule': Schedule,
        'LicensingMerchandising': LicensingMerchandising
    },
    data() {
        return {
            currentSlide: 0,
            totalSlides: 0,
        }
    },
    methods: {
        updateCounter() {
            const slidesComponent = this.$children[0]
            slidesComponent.$on('slideEnd', event => this.currentSlide = event.currentIndex)
        }
    },
    mounted() {
        this.totalSlides = this.$el.querySelector('#slides article').children.length
        this.updateCounter()
    }
}
</script>

<style lang='scss'>

@import './styles/mixins';
@import './styles/fonts';
@import './styles/vars';
@import './styles/reset';

body {
    background: black;
    color: white;
    font-family: $font-regular;
    font-weight: 400;
    font-size: 16px;
    @include fluid-type(320px, 1920px, 12px, 24px);
    @include bp {
        > * {
            display: none;
        }
        &:before {
            content: 'Please view on desktop.';
            position: absolute;
            color: white;
            font-size: 2em;
            font-weight: bold;
            top: 0; right: 10%; bottom: 0; left: 10%;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}

h1, h2, h3 {
    font-family: $font-display-bold;
    font-weight: normal;
}

h1 {
    @include fluid-type(320px, 1920px, 24px, 72px);
    line-height: 1.05;
    margin: 0;
}

h2 {
    margin: 0;
    font-size: 3.5vw;
    line-height: 1;
}

.title h2.sep {
    position: relative;
    &::after {
        content: '';
        margin: 2.5vh 0 1.25vh;
        display: block;
        width: 30px;
        height: 6px;
        background: white;
    }
}

p {
    font-family: $font-regular;
    margin: 0 0 2.5vh;
    line-height: 1.42;
    &:last-of-type {
        margin: 0;
    }
    @include bp() {
        margin: 0 0 1vh;
    }
}

p.large {
    padding: 2.5vh 0;
    font-weight: 400;
    @include fluid-type(320px, 1920px, 14px, 32px);
    @include bp() {
        padding: 0.75vh 0;
    }
}

ul {
    list-style-type: square;
}

li:not(:last-of-type) {
    margin-bottom: 5vh;
    @include bp() {
        margin-bottom: 1.25vh;
    }
}

button {
    font-weight: 600;
    @include fluid-type(320px, 1920px, 10px, 14px);
    letter-spacing: 0.1em;
    text-transform: uppercase;
    padding: 1.25vw 2.5vw;
    cursor: pointer;
    margin: 0 0 1em 0;
    transition: all 0.15s ease-out;
    border-radius: 2px;
    background: #3482ca;
    color: white;
    border: 1px solid #3482ca;
}

.title,
.content {
    z-index: 1;
}

#welcome {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    @include bg($color-blue);
    .content {
        position: relative;
        display: flex;
        width: 70%;
        align-items: center;
        @include bp() {
            flex-direction: column;
            text-align: center;
        }
    }
    .space-man {
        width: 50%;
        height: 100%;
        position: relative;
        img {
            width: 100%;
            @include bp() {
                width: 60%;
                margin-bottom: 2.5vh;
            }
        }
    }
    .title {
        width: 70%;
        text-align: center;
        display: flex;
        flex-direction: column;
        h1 {
            margin: 5% 0;
        }
        figure {
          margin: 0 auto 5%;
          width: 80%;
          img {
              width: 100%;
              display: block;
          }
        }
        figure.tb {
            width: 60%;
        }
    }
    h1 {
        margin-bottom: 0;
    }
    p { margin: 0; }
    p:first-of-type {
        font-weight: 800;
        text-transform: uppercase;
        letter-spacing: 0.1em;
        margin: 0 0 1.5vh;
    }
    button {
        margin: 1.5vh 0 0 0;
    }
    .title:hover button:hover {
        transition: all 0.15s ease;
        background: transparent;
        color: white;
    }
}

#welcome.active {
    .title * {
        opacity: 0;
        transform: translateY(10px);
    }
    figure {
        transform: scale(2, 1) translateY(-50%);
        filter: blur(5px);
        opacity: 0;
        transition: all 0s linear 0s;
    }
}

#welcome.active.complete {
    .title * {
        opacity: 1;
        transform: translateY(0px);
        transition: all 1s ease-out;
        @for $i from 1 through 3 {
            &:nth-child(#{$i}) {
                transition-delay: 0.3s * $i;
            }
        }
    }
    figure {
        transform: scale(1) translateY(0%);
        filter: blur(0px);
        opacity: 1;
        transition: all 0.7s $ease-out-bounce 0s;
    }
}

#welcome.complete {
    figure {
        transition: all 0s ease-in-out $slide-delay;
    }
}

#development {
    position: relative;
    display: flex;
    align-items: center;
    background: lighten(black, 15%);
    flex-direction: column;
    padding: 0 5%;
    @include bp() {
        flex-direction: column;
        justify-content: center;
    }
    .title {
        height: 30%;
        display: flex;
        align-items: center;
    }
    .title h2 {
        line-height: 1.1;
        color: white;
        @include fluid-type(320px, 1920px, 32px, 122px);
    }
    .content {
        height: 70%;
        width: 100%;
        margin: auto;
        display: grid;
        grid-gap: 0 5%;
        grid-template-columns: repeat(2, 1fr);
        .col h3 {
            margin: 2.5% 0;
        }
        .col h3 small {
            font-family: $font-regular;
            color: darken(white, 30%);
            font-size: 0.65em;
            display: block;
        }
        .col {
            margin: 0;
            padding: 1.5% 0 1.5% 0;
            color: white;
            @include fluid-type(320px, 1920px, 12px, 30px);
            @include bp() {
                padding: 0 5% 0 5%;
            }
        }
        .col:nth-of-type(1) {
            border-top: 10px solid rgba($color-orange, 1);
            @include bp() {
                border-top: none;
                border-top: 6px solid rgba($color-orange, 1);
            }
        }
        .col:nth-of-type(2) {
            border-top: 10px solid $color-gray;
            @include bp() {
                border-top: none;
                border-top: 6px solid $color-gray;
            }
        }
        .col:nth-of-type(3) {
            border-top: 10px solid $color-gold;
            @include bp() {
                border-top: none;
                border-top: 6px solid $color-gold;
            }
        }
        .col:nth-of-type(4) {
            border-top: 10px solid $color-green;
            @include bp() {
                border-top: none;
                border-top: 6px solid $color-green;
            }

        }
    }
}

#working-together {
    position: relative;
    display: flex;
    color: black;
    justify-content: center;
    @include bp() {
        flex-direction: column;
        justify-content: flex-end;
    }
    .title {
        padding: 0 8vw;
        width: 50%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        background: black;
        @include bp() {
            padding: 0 15% 8%;
            width: 100%;
            justify-content: flex-end;
        }
    }
    .title .logo {
        margin-bottom: 5vh;
        @include bp() {
            margin-bottom: 3vh;
            img {
                width: 80%;
            }
        }
    }
    .title .logo img {
        width: 100%;
        display: block;
        @include bp() {
            width: 80%;
        }
    }
    .title h2 {
        line-height: 1;
        display: block;
        color: white;
        width: 70%;
        margin: 0 0 10px;
        @include fluid-type(320px, 1920px, 32px, 62px);
        @include bp() {
            width: auto;
        }
    }
    .title h2.sep::after {
        background: $color-green;
    }
    p {
        color: $color-gray;
    }
    .content {
        width: 50%;
        @include bp() {
            width: auto;
        }
    }
    .sub-title {
        width: 10%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;
    }
    h3 {
        margin: 0;
        writing-mode: vertical-lr;
        color: white;
        display: flex;
        align-items: center;
        @include fluid-type(320px, 1920px, 14px, 30px);
    }
    li, p {
        margin: 1vh;
        line-height: 1.3;
    }
    .highlights {
        height: 50%;
        @include bp() {
            height: auto;
        }
        background: darken($color-green, 5%);
        .sub-title {
            background: lighten(black, 20%);
        }
    }
    .values {
        height: 50%;
        @include bp() {
            height: auto;
        }
        background: darken($color-green, 10%);
        .sub-title {
            background: lighten(black, 10%);
        }
        .inner-content p strong {
            font-weight: 800;
            text-transform: uppercase;
            letter-spacing: 0.05em;
        } 
    }
    .highlights, .values {
        display: flex;
        position: relative;
        p, li {
            color: white;
        }
    }
    .values .inner-content,
    .highlights .inner-content {
        padding: 0vh 10% 0 10%;
        margin: 0;
        position: relative;
        width: 90%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @include bp() {
            padding: 2.5vh 10%;
        }
    }
    .values .inner-content {
        background: #222;
    }
    .highlights .inner-content {
        background: #444;
    }
}

@keyframes rotate {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
@keyframes rotate2 {
    0% {
        transform: rotate(360deg) scale(1);
    }
    100% {
        transform: rotate(0deg) scale(1);
    }
}

#ip-global-exploitation-across-all-media {
    background: darken(white, 7.5%);
    color: black;
    align-items: center;
    justify-content: center;
    display: flex;
     h2 {
        font-size: 2.5vw;
        line-height: 1.35;
    }
    .title {
        position: absolute;
        top: 50%;
        left: 50%;
        text-align: center;
        width: 30%;
        display: flex;
        align-items: center;
        justify-content: center;
        transform: translate3d(-50%, -50%, 0);
    }
    .content {
        //background: transparent url('./assets/images/ip-hexagon.svg') 50% 50%/contain no-repeat;
        border: 3px solid white;
        margin: auto;
        width: 40vw;
        height: 40vw;
        border-radius: 400px;
        position: relative;
        animation: rotate 30s linear infinite;
    }
    figure.ip {
        margin: 0;
        position: absolute;
        animation: rotate2 30s linear infinite;
        .image {
            display: flex;
            align-items: center;
            justify-content: center;
            border: 3px solid white;
            width: 10vw;
            height: 10vw;
            overflow: hidden;
            border-radius: 300px;
        }
        img {
            width: inherit;
            height: inherit;
            object-fit: cover;
            transform: rotate(-15deg);
        }

        figcaption {
            text-align: center;
            position: absolute;
            background: none;
            font-weight: 500;
            font-size: 0.75em;
            left: -1vw; right: -1vw; bottom: 0;
            transform: translateY(110%);
            border-radius: 2px;
            padding: 0.35vw 1vw;
        }
    }
    figure.ip:nth-child(1) {
        top: -2vw;
        left: 5.15vw;
    }
    figure.ip:nth-child(2) {
        top: -2vw;
        right: 5.15vw;
    }
    figure.ip:nth-child(3) {
        top: 50%;
        margin-top: -5vw;
        right: -4.75vw;
    }
    figure.ip:nth-child(4) {
        bottom: -2vw;
        right: 5.15vw;
    }
    figure.ip:nth-child(5) {
        bottom: -2vw;
        left: 5.15vw;
    }
    figure.ip:nth-child(6) {
        top: 50%;
        margin-top: -5vw;
        left: -4.75vw;
    }
}

#intellectual-properties-evaluation-process,
#introduction-to-next-steps, {
    background: white;
    color: black;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-evenly;
    .title {
        height: 30%;
        width: 100%;
        padding: 0 10%;
        background: #222;
        color: white;
        align-items: center;
        display: flex;
        text-align: center; 
        justify-content: center;
    }
    .content {
        width: 55%;
        height: 70%;
        justify-content: center;
        flex-direction: column;
        display: flex;
        text-align: center;
/*        .col {
            column-gap: 5%;
            column-count: 2;
        }*/
    }
    ul {
        display: flex;
        list-style: none;
        padding: 0;
        margin: 0;
        text-align: center;
        li {
            font-size: 0.8em;
            width: 33%;
            text-align: center;
            padding: 0 2%;
            font-weight: bold;
            img {
                width: 50%;
                display: flex;
                margin: 0 auto 1vh;
            }
            small {
                margin-top: 1vh;
                display: block;
                color: lighten(black, 60%);
            }
        }
    }
}

#introduction-to-next-steps {
    .content {
        height: 80%;
    }
    .logos {
        display: flex;
        margin-top: 5vh;
        justify-content: space-evenly;
        img {
            width: 30%;
            height: 100%;
            object-fit: contain;
            display: block;
        }
        .tb {
            width: 20%;
            filter: brightness(0);
        }
    }
    .content > .inner {
        justify-content: center;
        text-align: center;
        margin-bottom: 5vh;
    }
    .title {
        height: 20%;
        background: darken(white, 10%);
        color: black;
    }
}

#preschool-to-primetime {
    background: black;
    display: flex;
    align-items: center;
    justify-content: center;
    @include bp() {
        flex-direction: column;
    }
    h2 {
        font-size: 4vw;
        color: darken(white, 10%);
        margin-bottom: 1vw;
        @include bp() {
            font-size: 20vw;
            color: darken(white, 15%);
        }
    }
    .title {
        position: absolute;
        left: 0; right: 0;
        text-align: center;
        top: 12.5vh;
        z-index: 3;
        @include bp() {
            top: initial;
        }
        p {
            font-size: 0.8em;
            max-width: 60%;
            margin: auto;
        }
    }
    .content {
        position: absolute;
        top: 0; left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: url('./assets/images/projects.jpg') 50% 100%/contain no-repeat;
        @include bp() {
            height: 50%;
            background-position: 0% 50%;
            background-size: 250% auto;
            &:before {
                content: '';
                position: absolute;
                top: 0; bottom: 0; right: 0; left: 0;
                background: inherit;
                background-position: 100% 50%;
                background-size: 250% auto;
                transform: translateY(100%);
            }
        }
    }
}

#business-and-creative-development {
    background: white;
    color: black;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .title {
        position: absolute;
        top: 10vh;
        text-align: center;
        left: 0; right: 0;
        h2 {
            font-size: 2.5vw;
        }
    }
    .grid {
        display: grid;
        grid-template-columns: repeat(3, 33%);
        grid-template-rows: repeat(3, 33%);
        height: 70%;
        figure {
            width: 80%;
            justify-self: center;
            align-self: center;
            img {
                margin-bottom: 2.5vw;
            }
        }
        .vrs {
            grid-row: 2/3;
        }
        .tbs {
            grid-row: 2/3;
            grid-column: 3/4;
        }
        .newco {
            transform: translateY(-50%);
            grid-column: 2/3;
            grid-row: 3/4;
        }
    }
    $border-color: darken(white, 15%);
    .root {
        position: relative;
        &:before,
        &:after {
            content: '';
            position: absolute;
            width: 90%;
            top: 50%;
            height: 2vw;
            margin-top: -2vw;
            border-bottom: 1px solid $border-color;
        }
        &:before {
            left: -90%;
            border-left: 1px solid $border-color;
        }
        &:after {
            right: -90%;
            border-right: 1px solid $border-color;
        }
    }

    img {
        width: 100%;
        display: block;
    }
    .tbs img {
        filter: brightness(0);
        width: 75%;
        margin-left: auto;
        margin-right: auto;
    }
    .newco img {
        width: 30%;
        margin-left: auto;
        margin-right: auto;
    }
    .footer {
        width: 100%;
        margin: 0;
    }
    figure {
        margin: 0;
        position: relative;
    }
    figcaption {
        text-align: center;
        span {
            padding: 1.5%;
            border: 1px solid $border-color;
            display: block;
            margin: 1vw;
        }
        small {
            display: block;
        }
    }
}

#projected-gross-revenues {
    display: flex;
    position: relative;
    .col {
        width: 50%;
    }
    h2 {
        font-size: 5vw;
    }
    li {
        position: relative;
        margin: 1vw 0;
        display: flex;
        justify-content: space-between;
        &:before {
            content: '—';
            position: absolute;
            left: 0;
            transform: translateX(-150%);
            opacity: 0.25;
        }
    }
    .col:first-of-type {
        padding: 5%;
        display: flex;
        background: black;
        flex-direction: column;
        justify-content: space-evenly;
        color: white;
    }
    .col:last-of-type {
        background: white url('./assets/images/projected-gross-rev.jpg') 50% 50%/contain no-repeat;
    }
}


#thank-you {
    background: black;
    
    .title {
        height: 50%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        background: lighten(white, 0%);
        align-items: center;
        padding: 5% 10% 0;
        @include bp() {
            height: 33.33%;
        }
        img {
            width: 20%;
        }
    }
    .title h2 {
        position: relative;
        bottom: 0;
        color: black;
        @include fluid-type(320px, 1920px, 48px, 60px);
        left: 0;
        line-height: 0.5;
        margin: 0;
    }
    .content {
        height: 50%;
        margin: auto;
        color: white;
        background: black;
        display: flex;
        align-items: center;
        justify-content: center;
        p {
            width: 60%;
            margin: auto;
        }
        @include bp() {
            height: 66.66%;
            grid-template-columns: 100%;
            grid-template-rows: 50% 50%;
        }
    }
    .content figure {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .content figure:nth-of-type(1) {
        background: lighten(black, 8%);
        img {
            width: 40%;
            display: block;
        }
    }
    .content figure:nth-of-type(2) {
        background: lighten(black, 10%);
        img {
            width: 50%;
            display: block;
        }
    }
}

/* 
    Counter
    --------------------------------------------------------
*/

.nav-icon {
    fill: darken(white, 50%);
}

#ui-display {
    position: fixed;
    padding: 0;
    bottom: 0; right: 0;
    height: 50px;
    z-index: 13367;
    display: flex;
    justify-content: flex-end;
    user-select: none;
    .logo {
        background: rgba(black, 0.85);
        position: relative;
        z-index: 9002;
        display: flex;
        width: 12vw;
        padding: 0 1vw;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 5px 0 0 0;
    }
    #logo {
        width: auto;
        height: 60%;
        margin: 0;
        fill: white;
        transition: all 0.3s linear;
    }

    .slide-counter {
        width: 4vw;
        text-transform: uppercase;
        letter-spacing: 0.1em;
        @include fluid-type(320px, 1920px, 10px, 12px);
        display: flex;
        background: lighten(black, 20%);
        align-items: center;
        justify-content: center;
        span {
            font-weight: bold;
            font-family: Sans-serif;
            text-align: center;
            color: darken(white, 0%);
            transition: all 0.3s ease-in-out;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/App.vue